/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1InfluencerId202,
  DeleteApiV1InfluencerId401,
  DeleteApiV1InfluencerId404,
  DeleteApiV1InfluencerId500,
  DeleteApiV1InfluencerIdMutationResponse,
  DeleteApiV1InfluencerIdPathParams,
} from "../../types/influencerRegistroController/DeleteApiV1InfluencerId.ts";

export const deleteApiV1InfluencerIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1InfluencerIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1InfluencerId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1InfluencerId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1InfluencerId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1InfluencerId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1InfluencerId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1InfluencerId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1InfluencerId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1InfluencerId500>;

export const deleteApiV1InfluencerIdMutationResponseSchema = z.lazy(
  () => deleteApiV1InfluencerId202Schema,
) as unknown as ToZod<DeleteApiV1InfluencerIdMutationResponse>;
